import React from 'react';
import { ErrorIcon, OkIcon } from '@flexiflow-ui-kit/icon';
import { useFlexiflowContext, FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;
var BannerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  min-height: 44px;\n  padding: 12px;\n  background: #f8f9fb;\n  color: ", ";\n  border-radius: 4px;\n  gap: 8px;\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
}, function (p) {
  return p.theme.predefinedCss.body2;
}, function (p) {
  return p.$error ? p.theme.palette.red['700'] : p.theme.palette.green['700'];
});

function Banner(_ref) {
  var children = _ref.children,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error;

  var _useFlexiflowContext = useFlexiflowContext(),
      palette = _useFlexiflowContext.theme.palette;

  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(BannerContainer, {
    $error: error
  }, error ? /*#__PURE__*/React.createElement(ErrorIcon, {
    height: 16,
    width: 16,
    color: palette.red['600']
  }) : /*#__PURE__*/React.createElement(OkIcon, {
    height: 16,
    width: 16,
    color: palette.green['700']
  }), /*#__PURE__*/React.createElement("div", null, children)));
}

export { Banner };
